import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const useAttributeModalStyles = makeStyles((theme) => ({
  dialogSubtitle: {
    color: COLORS.muted,
    marginTop: theme.spacing(0.5),
  },
  deleteConfirmBox: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    backgroundColor: '#fff3f0',
    borderRadius: theme.shape.borderRadius,
  },
  deleteConfirmActions: {
    marginTop: theme.spacing(1),
  },
  addFormColumn: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
}));
